// Blocos básicos usados pelas fórmulas clínicas.
//
// Convenção do módulo: toda função devolve `null` quando o resultado é indeterminado
// (campo em branco, divisor zero). Nunca `0`, nunca string — quem exibe é que decide se
// isso vira '--', 'Não calculado' ou 0. Isso existe porque as cópias antigas divergiam
// justamente aí, e a mesma avaliação saía diferente no PDF e na conclusão.

function isFilled(value) {
    return value !== undefined && value !== null && value !== '';
}

function anyFilled(...values) {
    return values.some(isFilled);
}

function hasFilledObject(value) {
    return Boolean(value) && typeof value === 'object' && Object.values(value).some(isFilled);
}

// Só converte o que foi realmente preenchido: `Number('')` e `Number(null)` valem 0, e
// tratar isso como zero fazia campo em branco virar nota máxima nos scores de tornozelo.
function toNumber(value) {
    if (!isFilled(value)) return null;

    const number = Number(value);
    return Number.isFinite(number) ? number : null;
}

// Usa toFixed de propósito: em negativos ele arredonda para longe do zero (-109.75 vira
// -109.8) enquanto Math.round arredonda para cima (-109.7). Os relatórios já publicados
// seguem a primeira regra, então mudar isso deslocaria valores antigos em 0.1.
function round(value, decimals = 1) {
    if (value === null || !Number.isFinite(value)) return null;

    return Number(value.toFixed(decimals));
}

// Zero é resultado válido de teste, não marcador de "não fez" — quem não fez deixa o
// campo em branco.
function average(values) {
    const numbers = (values || []).map(toNumber).filter((value) => value !== null);
    if (!numbers.length) return null;

    return round(numbers.reduce((total, value) => total + value, 0) / numbers.length);
}

function normalization(value, target) {
    const numerator = toNumber(value);
    const denominator = toNumber(target);
    if (numerator === null || denominator === null || denominator === 0) return null;

    return round((numerator / denominator) * 100);
}

function simpleNormalization(value, target) {
    const numerator = toNumber(value);
    const denominator = toNumber(target);
    if (numerator === null || denominator === null || denominator === 0) return null;

    return round(numerator / denominator);
}

const STRENGTH_CAPACITY_PERCENT = 68;
const STRENGTH_CAPACITY_DIVISOR = 15;

function strengthCapacityScore(value, weight) {
    const average = toNumber(value);
    const bodyWeight = toNumber(weight);
    if (average === null || bodyWeight === null) return null;

    return round((average * ((bodyWeight * STRENGTH_CAPACITY_PERCENT) / 100)) / STRENGTH_CAPACITY_DIVISOR);
}

module.exports = {
    isFilled,
    anyFilled,
    hasFilledObject,
    toNumber,
    round,
    average,
    normalization,
    simpleNormalization,
    strengthCapacityScore
};
